import { gql } from '@apollo/client';

import { LiveBroadcastFragment } from '../fragments';

export const SetLiveBroadcastMutation = gql`
    mutation setLiveBroadcast($link: String!, $active: Boolean!) {
        setLiveBroadcast(link: $link, active: $active) {
            ...LiveBroadcast
        }
    }
    ${LiveBroadcastFragment}
`;
